import type { ReactNode } from "react";
import Tooltip from "@imminently/decisively-ui/Tooltip";
import { getEventTypeDisplayName, getEventTypeInfo } from "@packages/commons";
import { EventIcon } from "./EventIcon";

export const EventListContent = ({ eventType, message, timestamp, actions, expanded = false }: {
  eventType?: string;
  message?: string;
  timestamp: string;
  actions?: ReactNode;
  expanded?: boolean;
}) => {
  const info = getEventTypeInfo(eventType);
  const name = getEventTypeDisplayName(eventType);
  return (
    <div className="flex min-w-0 flex-1 items-start gap-3">
      <EventIcon eventType={eventType} className="mt-0.5 shrink-0 text-textSecondary" />
      <div className="min-w-0 flex-1">
        <div className="flex min-w-0 items-start justify-between gap-2">
          <Tooltip>
            <Tooltip.Trigger asChild>
              <div className="flex min-w-0 flex-1 flex-wrap items-baseline gap-x-1 text-sm" tabIndex={0} aria-label={`${name} - ${timestamp}`}>
                <span className="min-w-0 truncate font-medium">{name}</span>
                <span className="text-xs text-textSecondary">- {timestamp}</span>
              </div>
            </Tooltip.Trigger>
            <Tooltip.Content placement="bottom">
              <div className="max-w-sm space-y-1">
                {info?.name && <div className="font-medium">{info.name}</div>}
                <code className="block break-all text-xs">{eventType || "Unknown event type"}</code>
                {info?.description && <p className="text-sm">{info.description}</p>}
              </div>
            </Tooltip.Content>
          </Tooltip>
          {actions && <div className="flex shrink-0 flex-wrap items-center justify-end gap-1">{actions}</div>}
        </div>
        <div className={`mt-1 whitespace-pre-wrap break-words text-sm text-[var(--subtle-dark)] ${expanded ? "" : "line-clamp-2"}`}>{message || "No message"}</div>
      </div>
    </div>
  );
};
